import {
  APP_PREFIX,
  SERVICE_REQUEST_ARRANGEMENT_COMPOSE,
  SERVICE_REQUEST_ARRANGEMENT_INITIAL,
  SERVICE_REQUEST_ARRANGEMENT_PAGE,
} from '@app/routes/urls';

/**
 * The patient an authoring screen opens on, carried in the URL rather than in navigation
 * state: a link that survives a reload and can be shared is worth more here than saving the
 * one fetch, and the surfaces that link here hold three different shapes of the same patient
 * — only the id is common to all of them.
 */
export const ARRANGEMENT_CLIENT_PARAM = 'clientId';

const ARRANGEMENT_BASE = `/${APP_PREFIX}/${SERVICE_REQUEST_ARRANGEMENT_PAGE}`;

/** Step 0 — the three-card chooser, and what "start over" and an empty composer both return to. */
export const arrangementInitialPath = `${ARRANGEMENT_BASE}/${SERVICE_REQUEST_ARRANGEMENT_INITIAL}`;

/** The composer, reachable only by picking one of step 0's three cards. */
export const arrangementComposePath = `${ARRANGEMENT_BASE}/${SERVICE_REQUEST_ARRANGEMENT_COMPOSE}`;

/**
 * The authoring screen's step 0, optionally opened on a patient.
 *
 * Points at `arrangementInitialPath` rather than the bare section path: that path still works
 * (it redirects, keeping the query string — see `RoutingTransformer.tsx`), but a link that opens
 * step 0 directly does not depend on the redirect existing.
 */
export const newArrangementPath = (clientId?: number): string =>
  clientId ? `${arrangementInitialPath}?${ARRANGEMENT_CLIENT_PARAM}=${clientId}` : arrangementInitialPath;
